// src/context/UserContext.js
import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes

export const ProductContext = createContext(null);

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    console.log("Products context", products);
  }, [products]);

  return (
    <ProductContext.Provider value={{ products, setProducts }}>{children}</ProductContext.Provider>
  );
};

ProductProvider.propTypes = {
  children: PropTypes.node.isRequired, // Define the 'children' prop
};
